<template>
  <Modal class-name="vertical-center-modal"
         v-model="isWithdraw"
         title="提现">
    <div class="form-wrapper">
      <!--<div class="withdraw-tip">提示：提现收取1%手续费，实际打款金额为提现金额的99%</div>-->
      <Form :model="withdrawForm"
            label-position="right"
            :label-width="100"
            :rules="ruleValidate">
				<FormItem label="真实姓名">
					<div class="form-group">
						<Input v-model="withdrawForm.name" placeholder="请输入真实姓名" />
					</div>
				</FormItem>
        <FormItem label="支付宝账号">
          <div class="form-group">
            <Input v-model="withdrawForm.alipay" placeholder="请输入支付宝账号" />
          </div>
        </FormItem>
        <FormItem label="提现金额(元)">
          <div class="form-group">
            <Input v-model="withdrawForm.withdraw" placeholder="请输入提现金额" />
            <p style="font-size:14px">最大可提现金额：<span class="normal-font">{{maxCanWithdraw}}</span> 元</p>
          </div>
        </FormItem>
      </Form>
    </div>
    <div slot="footer">
      <div class="footer-wrapper">
        <span class="btn confirm-btn" @click="handelSubmit">提交</span>
      </div>
    </div>
    <Spin size="large" fix v-if="spinShow"></Spin>
  </Modal>
</template>

<script>
  import { getPlatformUuidKfc } from '@/utils/auth'
  import { Modal, Form, FormItem, Input, Spin } from 'view-design'
  import  withdraw from '@/javaApi/kfc/withdraw.js'
  const withdrawModel = new withdraw()
  export default {
    name: "Withdraw",
    components: {
      Modal,
      Form,
      FormItem,
      Input,
      Spin
    },
    props: {
      /* info: {
        type: Object,
        default: {}
      }, */
    },
    created() {
      //console.log(this.info)
    },
    data: function () {
      return {
        isWithdraw: false,
        withdrawForm: {
          name: '',
          alipay: '',
          withdraw: ''
        },
        loading:false,
        ruleValidate: {},
        maxCanWithdraw: '0.00',
        spinShow:true
      }
    },
    computed:{
      platformUuid(){
        return getPlatformUuidKfc()
      }
    },
    methods: {
      init: function () {
        this.queryBasicInfo()
        this.isWithdraw = true
      },
      handelCancel: function () {
        this.isWithdraw = false
      },
      queryBasicInfo(){
        let param = {
          platformUuid:this.platformUuid
        }
        let that = this
        withdrawModel.getWithdrawInfo(param).then(response=>{
          that.spinShow = false
          let res = response.data
          if(res.code == 200){
            if(res.data){
              let list = res.data
              if(list){
                this.withdrawForm.name= list.name?list.name:''
                this.withdrawForm.alipay = list.alipay?list.alipay:''
                this.maxCanWithdraw = list.balance?parseFloat(list.balance).toFixed(2):'0.00'
              }
            }
          }else{
            let message = res.message?res.message:'系统异常请稍后再试试'
            that.$Message.error(message)
          }
        }).catch(error=>{
          console.log(error)
          that.spinShow = false
            if(error != 'token invalid'){
                that.$Message.error('系统异常请稍后再试！')
            }
        })
      },
      handelSubmit: function () {
        let that = this
        if(this.loading){
          return
        }
        if(!this.withdrawForm.name){
          this.$Message.error('请填写真实姓名')
          return
        }
        if(!this.withdrawForm.alipay){
          this.$Message.error('请填写支付宝账号')
          return
        }
        let alipayReg =  /^(?:1[3-9]\d{9}|[a-zA-Z\d._-]*\@[a-zA-Z\d.-]{1,10}\.[a-zA-Z\d]{1,20})$/
        if(!alipayReg.test(this.withdrawForm.alipay)){
          this.$Message.error('请填写正确的支付宝账号格式！')
          return
        }
        if(!this.withdrawForm.withdraw){
          this.$Message.error('请填写提现金额')
          return
        }
        let money = parseFloat(this.withdrawForm.withdraw)?parseFloat(this.withdrawForm.withdraw):0
        if(money<=0){
          this.$Message.error('提现金额请填写大于0的数字')
          return
        }
        if(money>this.maxCanWithdraw){
          this.$Message.error('提现金额超出最大范围')
          return
        }
        this.loading = true
        this.withdrawForm.platformUuid = this.platformUuid
        withdrawModel.insertWithdrawRecord(this.withdrawForm).then(response => {
          that.loading = false
          let res = response.data
          if(res.code == 200){
              that.$Message.success(res.message)
              this.maxCanWithdraw = res.data.balance ? parseFloat(res.data.balance).toFixed(2) : '0.00'
              that.handelCancel();
              this.$emit('close',this.maxCanWithdraw)
          }else{
           let message = res.message?res.message:'系统异常请稍后再试'
           that.$Message.error(message)
          }
        }).catch(error => {
          that.loading = false
          that.$Message.error('系统异常请稍后再试')
          console.log(error)
        })
      }
    }
  }
</script>

<style scoped>
.withdraw-tip{
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #FF4F76;
  padding: 0 10px 20px 10px;
}
.normal-font {
  color: #FF4F76;;
  font-size: 14px;
}
>>> .ivu-modal-body {
  padding: 16px 16px 0px 16px;
}
>>> .ivu-modal-content{
  border-radius: 0;
}
>>> .vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;
}
>>> .vertical-center-modal .ivu-modal {
  top: 0;
}
>>> .ivu-input{
  border-radius: 2px;
}
>>> .form-wrapper .form-group .ivu-input:focus {
  border: 1px solid #D63036 !important;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(255, 150, 43, 0.6) !important;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(255, 150, 43, 0.6) !important;
  outline: none;
}
>>> .form-wrapper .form-group .ivu-input:hover {
  border-color: #D63036;
}
>>> .vertical-center-modal .ivu-modal-footer {
  border-top: none;
  padding: 0px 18px 12px 18px;
  text-align: right;
}

.footer-wrapper {
  display: flex;
  min-width: 0;
  width: 100%;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.footer-wrapper .btn {
  display: inline-block;
  border-radius: 2px;
  margin-right: 10px;
  padding: 0px 20px;
  font-size: 14px;
  height: 36px;
  line-height: 36px;
  vertical-align: middle;
  cursor: pointer;
}
.footer-wrapper .btn.confirm-btn {
  background: #D63036;
  color: #fff;
}
.footer-wrapper .btn.cancel-btn {
  border: 1px solid #eeeeee;
  border-radius: 2px;
  color: #222222;
}
</style>



// WEBPACK FOOTER //
// src/components/kfc/Withdraw.vue